/** Reusable JSON-LD schema generators for SEO */

export function buildBreadcrumbList(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function buildFaqSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
}

export function buildArticleSchema(opts: {
  headline: string;
  description: string;
  url: string;
  image: string;
  datePublished: string;
  dateModified?: string;
  author?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: opts.headline,
    description: opts.description,
    url: opts.url,
    image: opts.image,
    datePublished: opts.datePublished,
    dateModified: opts.dateModified ?? opts.datePublished,
    author: {
      "@type": "Person",
      name: opts.author ?? "Hintsly",
    },
    publisher: {
      "@type": "Organization",
      name: "Hintsly",
      url: "https://hintsly.com.au",
      logo: {
        "@type": "ImageObject",
        url: "https://hintsly.com.au/images/hintsly-logo.webp",
      },
    },
  };
}

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Hintsly",
  url: "https://hintsly.com.au",
  logo: "https://hintsly.com.au/images/hintsly-logo.webp",
  description:
    "Australia's free gift registry and wishlist platform. Eliminate unwanted gifts, reduce waste, and give meaningful presents every time.",
  foundingDate: "2025",
  founder: {
    "@type": "Person",
    name: "Jessica",
  },
  address: {
    "@type": "PostalAddress",
    addressCountry: "AU",
  },
  sameAs: [
    "https://instagram.com/hintslyau",
    "https://facebook.com/hintslyau",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    email: "gift@hintsly.com.au",
    url: "https://hintsly.com.au/contact",
  },
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Hintsly",
  url: "https://hintsly.com.au",
  description:
    "Australia's free gift registry and wishlist platform. Build your list, share the hint, and get gifts you'll genuinely love.",
  publisher: {
    "@type": "Organization",
    name: "Hintsly",
  },
};
